import React from 'react';
import { AppContext } from '../AppContext';

const Settings = (props) => {
    const app = React.useContext(AppContext);

    return (
        <div id="Settings1" className="page1">
            <div className="wrapper">
                <div className="pageTitle">
                    <a className="backButton" href="#"></a>
                    <h1>Settings</h1>
                </div>
 
            </div>
        </div>
    )
};

export default Settings;

